import httpHelper from "@/helpers/httpHelper";
// action types
export const GETUSER = "getUser"; 

// mutation types
export const SET_USER = "setUser";

export default {
    state: {
        
        userInformation:null,
        
    },
    getters: {
        /**
         * loade list of Gateway
         * @param state
         * @returns {*}
         */
        loadedUserInformation(state) {
            return state.userInformation;
        },
    },
    actions: {
        /**
         * Set the  
         * @param state
         * @param payload
         */
         [GETUSER](context,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .getData('users/verify',payload)
                .then((response) => {
                    
                    context.commit(SET_USER,response)
                  
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
    },
    mutations: {
       
        [SET_USER](state, payload) {
            state.userInformation = payload
        }
    }
};